<!--  台幣tag -->
<template>
<span>
    <template v-if="tagName =='保'">
      <v-chip text-color="white"
              class="color-primary circle">{{tagName}}</v-chip>
    </template>
    <template v-if="tagName =='未'">
      <v-chip text-color="white"
              class="color-secondary circle">{{tagName}}</v-chip>
    </template>
    <template v-if="tagName =='簽'">
      <v-chip text-color="white"
              class="color-accent circle">{{tagName}}</v-chip>
    </template>
</span>
</template>
<script>
export default {
  name: 'base-tag-circle',
  props: {
    tagName: String,
    tagPrimary: {
      type: Boolean,
      default: false
    },
    tagSecondary: {
      type: Boolean,
      default: false
    },
    tagAccent: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="stylus" scoped>

.v-chip
  font-size $font-size-sm!important
  height 22px!important
  min-width: 22px!important
  justify-content: center!important
  margin-right:10px
.color-primary {
  background-color: $tag-primary !important;
  border-color: $tag-primary !important;
}

.color-secondary {
  background-color: $tag-secondary !important;
  border-color: $tag-secondary !important;
}

.color-accent {
  background-color: $tag-accent !important;
  border-color: $tag-accent !important;
}

</style>
<style>
.circle>.v-chip__content{
  padding: 0 5px!important;
  font-weight: bold
}
</style>
